import { all } from "redux-saga/effects";
import watchShopSaga from "./sagas/shopSaga";

export function* rootSaga() {
  yield all([watchShopSaga()]);
}
